
define('app/env',['backbone', 'marionette'], function(Backbone, Marionette) {
    
    var env = {};
    
    return env;
});